export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العروض"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["صفقاتي"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعلاناتي"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["التداولات"])}
}